/* ------------------------------------------------------------------------------
 *
 *  # Form Components Module
 *
 *  Form related functionality (datepicker, select2, file upload)
 *
 * ---------------------------------------------------------------------------- */

// Date picker
export function componentDatepicker() {
    if (typeof Datepicker == 'undefined') {
        console.warn('Warning - datepicker.min.js is not loaded.');
        return;
    }

    // Basic example
    const dpBasicElement = document.querySelector('.datepicker-basic');
    if (dpBasicElement) {
        const dpBasic = new Datepicker(dpBasicElement, {
            container: '.content-inner',
            buttonClass: 'btn',
            prevArrow: document.dir == 'rtl' ? '&rarr;' : '&larr;',
            nextArrow: document.dir == 'rtl' ? '&larr;' : '&rarr;'
        });
    }

    for (let dpBasicElement2 of document.querySelectorAll('.datepicker-prospecto')) {
        const dpBasic2 = new Datepicker(dpBasicElement2, {
            container: '.content-inner',
            buttonClass: 'btn',
            prevArrow: document.dir == 'rtl' ? '&rarr;' : '&larr;',
            nextArrow: document.dir == 'rtl' ? '&larr;' : '&rarr;'
        });
    }
}

// Select2
export function componentSelect2() {
    if (!$().select2) {
        console.warn('Warning - select2.min.js is not loaded.');
        return;
    };
    // Basic example
    $('.form-control-select2').select2().val(null).trigger('change');

    //
    // Select with icons
    //

    // Format icon
    function iconFormat(icon) {
        if (!icon.id) { return icon.text; }
        let $icon = '<i class="ph-' + $(icon.element).data('icon') + '"></i>' + icon.text;

        return $icon;
    }

    // Initialize with options
    $('.form-control-select2-icons').select2({
        templateResult: iconFormat,
        minimumResultsForSearch: Infinity,
        templateSelection: iconFormat,
        escapeMarkup: function (m) { return m; }
    }).val(null).trigger('change');
}

// Bootstrap file upload
export function componentFileUpload() {
    if (!$().fileinput) {
        console.warn('Warning - fileinput.min.js is not loaded.');
        return;
    }

    //
    // Define variables
    //

    // Buttons inside zoom modal
    const previewZoomButtonClasses = {
        rotate: 'btn btn-light btn-icon btn-sm',
        toggleheader: 'btn btn-light btn-icon btn-header-toggle btn-sm',
        fullscreen: 'btn btn-light btn-icon btn-sm',
        borderless: 'btn btn-light btn-icon btn-sm',
        close: 'btn btn-light btn-icon btn-sm'
    };

    // Icons inside zoom modal classes
    const previewZoomButtonIcons = {
        prev: document.dir == 'rtl' ? '<i class="ph-arrow-right"></i>' : '<i class="ph-arrow-left"></i>',
        next: document.dir == 'rtl' ? '<i class="ph-arrow-left"></i>' : '<i class="ph-arrow-right"></i>',
        rotate: '<i class="ph-arrow-clockwise"></i>',
        toggleheader: '<i class="ph-arrows-down-up"></i>',
        fullscreen: '<i class="ph-corners-out"></i>',
        borderless: '<i class="ph-frame-corners"></i>',
        close: '<i class="ph-x"></i>'
    };

    // File actions
    const fileActionSettings = {
        zoomClass: '',
        zoomIcon: '<i class="ph-magnifying-glass-plus"></i>',
        dragClass: 'p-2',
        dragIcon: '<i class="ph-dots-six"></i>',
        removeClass: '',
        removeErrorClass: 'text-danger',
        removeIcon: '<i class="ph-trash"></i>',
        indicatorNew: '<i class="ph-file-plus text-success"></i>',
        indicatorSuccess: '<i class="ph-check file-icon-large text-success"></i>',
        indicatorError: '<i class="ph-x text-danger"></i>',
        indicatorLoading: '<i class="ph-spinner spinner text-muted"></i>'
    };

    //
    // Basic example
    //

    $('.file-input').fileinput({
        browseLabel: 'Búscar',
        browseIcon: '<i class="ph-file-plus me-2"></i>',
        uploadIcon: '<i class="ph-file-arrow-up me-2"></i>',
        removeIcon: '<i class="ph-x fs-base me-2"></i>',
        layoutTemplates: {
            icon: '<i class="ph-check"></i>'
        },
        uploadClass: 'btn btn-light',
        removeClass: 'btn btn-light',
        initialCaption: "Seleccionar un archivo en formato excel",
        previewZoomButtonClasses: previewZoomButtonClasses,
        previewZoomButtonIcons: previewZoomButtonIcons,
        fileActionSettings: fileActionSettings
    });
}

//Ajax Loading
export function ajaxLoading() {
    if (window.appGlobals?.isJQuery) {
        $(document).ajaxComplete(function (e, request, options) {
            $('#loaderAjax').hide();
        });

        $(document).ajaxSend(function (e, request, options) {
            if (e.target.activeElement.offsetParent == null || e.target.activeElement.offsetParent.className.indexOf('chosen') == -1) {
                $('#loaderAjax').show();
            }
        });
    }
}

// Fancy tree
export function initComponentFancytree() {
    if (typeof Fancytree !== 'undefined') {
        Fancytree.init();
    }
}
